export const ReportTypes = {
  periodSalesByRoomType: 'periodSalesByRoomType',
  periodSalesBySubject: 'periodSalesBySubject',
  periodSalesByChannel: 'periodSalesByChannel',
  periodDeposits: 'periodDeposits',
  periodRefunds: 'periodRefunds',
  dailyOperations: 'dailyOperations',
  dailySalesReport: 'dailySalesReport',
  monthlySalesReport: 'monthlySalesReport',
  monthlySalesBySubjects: 'monthlySalesBySubjects',
  monthlySales: 'monthlySales',
  monthlySalesByDepartments: 'monthlySalesByDepartments',
  monthlyActualOperations: 'monthlyActualOperations',
  monthlyBreakdownOfGuests: 'monthlyBreakdownOfGuests',
  monthlySalesByRoomType: 'monthlySalesByRoomType',
  monthlySalesByChannel: 'monthlySalesByChannel',
  monthlyAccommodationTourism: 'monthlyAccommodationTourism',
  yearlySalesByDepartments: 'yearlySalesByDepartments',
  yearlySalesByRoomType: 'yearlySalesByRoomType',
  monthlyStampTaxSummary: 'monthlyStampTaxSummary',
}
export type ReportTypes = (typeof ReportTypes)[keyof typeof ReportTypes]

export const ReportTypeNames: { [key: ReportTypes]: string } = {
  [ReportTypes.periodSalesByRoomType]: '部屋タイプ別売上',
  [ReportTypes.periodSalesBySubject]: '科目別売上',
  [ReportTypes.periodSalesByChannel]: '予約経路別売上',
  [ReportTypes.periodDeposits]: '売掛先（支払い方法）別入金',
  [ReportTypes.periodRefunds]: '返金',
  [ReportTypes.dailyOperations]: '運用帳票',
  [ReportTypes.monthlySalesBySubjects]: '科目集計',
  [ReportTypes.monthlySales]: '売上月報',
  [ReportTypes.monthlySalesByDepartments]: '部門別売上',
  [ReportTypes.monthlyActualOperations]: '月間タイプ別稼働実績表',
  [ReportTypes.monthlyBreakdownOfGuests]: '宿泊人数内訳',
  [ReportTypes.monthlySalesByRoomType]: '前年同月比部屋タイプ別売上',
  [ReportTypes.monthlySalesByChannel]: '前年同月比予約経路別売上',
  [ReportTypes.monthlyAccommodationTourism]: '宿泊旅行統計調査',
  [ReportTypes.yearlySalesByDepartments]: '前年比部門別売上',
  [ReportTypes.yearlySalesByRoomType]: '前年比部屋タイプ別売上',
  [ReportTypes.monthlyStampTaxSummary]: '印紙税額集計',
}

export enum ReportPeriods {
  custom = 'custom',
  day = 'day',
  month = 'month',
  year = 'year',
}

export enum ExportStatus {
  success = 'success',
  inProcess = 'inProcess',
  error = 'error',
}

export type ExportHistory = {
  id: string
  createdAt: string
  format: string
  period: string
  name: string
  status: ExportStatus
  url: string | undefined
}

export const formatRadioItems = [
  { value: 'pdf', label: 'PDF' },
  { value: 'csv', label: 'CSV' },
]
export const taxRadioItems = [
  { value: '1', label: '税込' },
  { value: '0', label: '税抜' },
]

export const periodReportTypes = [
  ReportTypes.periodSalesBySubject,
  ReportTypes.periodSalesByRoomType,
  ReportTypes.periodSalesByChannel,
  ReportTypes.periodDeposits,
  ReportTypes.periodRefunds,
]
export const dailyReportTypes = [ReportTypes.dailyOperations]
export const monthlyReportTypes = [
  ReportTypes.monthlySalesBySubjects,
  ReportTypes.monthlySales,
  ReportTypes.monthlySalesByDepartments,
  ReportTypes.monthlySalesByRoomType,
  ReportTypes.monthlySalesByChannel,
  ReportTypes.monthlyActualOperations,
  ReportTypes.monthlyBreakdownOfGuests,
  ReportTypes.monthlyAccommodationTourism,
  ReportTypes.monthlyStampTaxSummary,
]
export const yearlyReportTypes = [ReportTypes.yearlySalesByDepartments, ReportTypes.yearlySalesByRoomType]

export const enabledTax = [
  ReportTypes.periodSalesByRoomType,
  ReportTypes.periodSalesBySubject,
  ReportTypes.periodSalesByChannel,
  ReportTypes.dailyOperations,
  ReportTypes.monthlySalesBySubjects,
  ReportTypes.monthlySales,
  ReportTypes.monthlySalesByDepartments,
  ReportTypes.monthlySalesByRoomType,
  ReportTypes.monthlySalesByChannel,
  ReportTypes.yearlySalesByDepartments,
  ReportTypes.yearlySalesByRoomType,
]
export const enabledSubjectSelectTypes = [ReportTypes.monthlySalesBySubjects, ReportTypes.dailyOperations]

export const storeSearchSubjectHistory = (type: ReportTypes | string, subjectCodes: string[]) => {
  if (!enabledSubjectSelectTypes.includes(type as ReportTypes)) {
    return
  }
  if (type === ReportTypes.monthlySalesBySubjects) {
    type = 'salesBySubjectsMonthly'
  }
  const storageKey = `${type}.history`
  const storedHistories = JSON.parse(localStorage.getItem(storageKey) || '[]')
  const newHistory = subjectCodes.join(',')
  const replaceHistories = storedHistories.filter(sh => sh !== newHistory)
  replaceHistories.unshift(newHistory)
  localStorage.setItem(storageKey, JSON.stringify(replaceHistories.slice(0, 5)))
}

export const getStoredSearchSubjectHistory = (type: ReportTypes | string): Array<string[]> => {
  // 既存の履歴互換のためにキー名を踏襲
  if (type === ReportTypes.monthlySalesBySubjects) {
    type = 'salesBySubjectsMonthly'
  }
  const storageKey = `${type}.history`
  return JSON.parse(localStorage.getItem(storageKey) || '[]').map((sh: string) => sh.split(','))
}
